import ApiService from "../ApiService";

const stateService = {
    getStates() {
        return ApiService.get(`/state`);
    },
    createState(formData) {
        return ApiService.post("/state/save", formData);
    },
    updateState(id, formData) {
        return ApiService.post(`/state/update?id=${id}`, formData);
    },
    deleteState(data) {
        return ApiService.post(`/state/remove`, data);
    }
};

export default stateService;